import React from 'react';
import FormBuilder from './FormBuilder';
import '../styles/ManageCurriculums.css';
import '../styles/ManageRanks.css';
import './FormBuilder.css';

/**
 * Form Builder page shell.
 *
 * Renders as a dashboard view inside `page-container`, using the same
 * `mc-page` / `universal-white-container mc-shell` wrapper as Manage Curricula
 * so the page reads as part of the platform rather than its own island.
 *
 * The hero and templates list live in <FormBuilder />; this file is only the
 * shell. (It previously also fetched templates itself — with a bare `axios`
 * call to a relative, unauthenticated `/form_builder/...` URL that could never
 * resolve — into a panel that had no way to be opened. That dead path is gone.)
 */
const FormBuilderPage = () => (
    <div className="mc-page">
        <div className="universal-white-container mc-shell form-builder-shell">
            <FormBuilder />
        </div>
    </div>
);

export default FormBuilderPage;
